"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadsUpPanel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var commonFunctions_1 = require("../commonFunctions");
var IPTDisclamer_1 = require("./IPTDisclamer");
var components_1 = require("@athena-portal/components");
var HeadsUpPanel = /** @class */ (function (_super) {
    __extends(HeadsUpPanel, _super);
    function HeadsUpPanel(props) {
        return _super.call(this, props) || this;
    }
    HeadsUpPanel.prototype.render = function () {
        if (this.props.policies && this.props.subscription) {
            var neverHigherAmountForSubscription = (0, commonFunctions_1.getNeverHigherPeriodAmount)(this.props.interaction);
            return ((0, jsx_runtime_1.jsxs)("div", { className: "section-panel", children: [this.props.wordingHtml, (0, jsx_runtime_1.jsx)("p", { className: "text-center mx-4 mb-0", children: "Your price could go up or down, but we guarantee you won't pay more than" }), (0, jsx_runtime_1.jsx)("p", { className: "text-center font-weight-bold mx-4", children: (0, commonFunctions_1.getNeverHigherPeriodWording)(this.props.interaction, neverHigherAmountForSubscription, this.props.policies) }), (0, jsx_runtime_1.jsx)(IPTDisclamer_1.default, { cssClass: "text-center mt-4 mx-4 mb-0" })] }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true });
        }
    };
    return HeadsUpPanel;
}(React.Component));
exports.HeadsUpPanel = HeadsUpPanel;
//# sourceMappingURL=HeadsUpPanel.js.map